<template>
  <nav class="navbar" :class="[type, {'is-scrolled': scrolled, 'is-fixed-top': fixedTop}]">
    <div class="container">
      <div class="is-flex has-content-spaced">
        <div class="flex-item">
          <a href="/" class="logo">
            <img src="@/assets/img/logo.png" alt="GoMediCAL">
          </a>
        </div>
        <div class="flex-item actions">
          <join-button/>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import JoinButton from './JoinButton'

export default {
  components: {
    JoinButton
  },

  props: {
    fixedTop: Boolean,
    type: String
  },

  data () {
    return {
      scrolled: false
    }
  },

  mounted () {
    window.addEventListener('scroll', (event) => {
      if (window.scrollY > 100) {
        this.scrolled = true
      } else {
        this.scrolled = false
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue